/**
 * List of DOM events that indicate user activity
 * Used for idle detection and user activity tracking
 */
export const ACTIVITY_EVENTS = [
  'mousedown',
  'mousemove', 
  'keypress',
  'scroll',
  'touchstart',
  'click',
  'keydown',
  'resize',
  'focus'
] as const;

/**
 * Default idle timeout in milliseconds (30 seconds)
 */
export const DEFAULT_IDLE_TIMEOUT = 30000;
